module.exports = __webpack_public_path__ + "img/france.906cfd16.png";